"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.More = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var More = function More() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "6",
      cy: "12",
      r: "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "18",
      cy: "12",
      r: "2"
    })]
  });
};
exports.More = More;